import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { STORAGE_KEYS } from '../constants/storage.constants';

/**
 * Prevents authenticated applicants from accessing login/signup routes
 */
export const guestGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  let tokenInStorage: string | null = null;
  try {
    tokenInStorage = sessionStorage.getItem(STORAGE_KEYS.AUTH_TOKEN);
  } catch {
    // Ignore
  }

  if (authService.isAuthenticated() && tokenInStorage) {
    const targetRoute = authService.getRoleHomeRoute();
    return router.createUrlTree([targetRoute]);
  }

  return true;
};
